<template>
  <div class="competitions-page event-details">
    <loading v-if="loading"></loading>
    <div class="wro-categories" v-else>
      <div class="m-container">
        <!-- breadcrumbs -->
        <div class="bread-crumbs-holder">
          <q-breadcrumbs active-color="Black" separator=">">
            <q-breadcrumbs-el label="Event" to="/event" />
            <q-breadcrumbs-el label="Wro-Event" to="/event/details" />
          </q-breadcrumbs>
        </div>
        <!-- breadcrumbs -->

        <!-- Events Details Header  -->
        <div class="text">
          <p class="text-capitalize mb-15">{{ event_details.title }}</p>
        </div>
        <div class="wro-categories-textContent">
          <img class="event-image" :src="event_details.image">
          <div class="overleay"></div>
          <div class="content">
            <p class="text-capitalize">{{ event_details.description }}</p>
          </div>
        </div>

        <!-- Events Details Body -->
        <div class="details-body text-right mx-15">

          <div class="the-button">
            <button class="wro-button secondaryButtons" @click="subscribe">
              <q-spinner color="purple-1" size="2em" :thickness="2" v-if="spinner_loading" />
              <span v-else>{{ isSubscribed ? 'Enroll Now' : 'Subscribe' }}</span>
            </button>
            <span class="skew-line-w"></span>
          </div>
        </div>

        <!-- Table -->
        <div class="the-table">
          <div class="event-details-header">
            <div class="tabs-wrapper">
              <p class="text">LeaderBoard</p>
              <q-tabs v-model="tab" dense class="text-grey" active-color="primary" indicator-color="primary"
                align="justify" narrow-indicator>
                <q-tab name="1" label="Round 1"></q-tab>
                <q-tab name="2" label="Round 2"></q-tab>
                <q-tab name="3" label="Round 3"></q-tab>
              </q-tabs>
            </div>
            <router-link :to="'/event/details/all-leaderBoard/'+ $route.params.id">See All</router-link>
          </div>


          <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="1">
              <!-- table -->
              <div class="q-pa-md">
                <q-markup-table>
                  <thead>
                    <tr>
                      <th class="text-left">#</th>
                      <th class="text-left">City</th>
                      <th class="text-left">Team</th>
                      <th class="text-left">Total Score</th>
                      <th class="text-left">Total Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="table.length > 0">
                      <tr v-for="(infos, index) in table.slice(0, 9)" :key="infos.id">
                        <td class="text-left">{{ index + 1 }}</td>
                        <td class="text-left">{{ infos.event_name }}</td>
                        <td class="text-left">{{ infos.team_name }}</td>
                        <td class="text-left">{{ infos.score }}</td>
                        <td class="text-left">{{ infos.time }}</td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td class="text-center" colspan="5">There is no data to show</td>
                    </tr>
                  </tbody>
                </q-markup-table>
              </div>
            </q-tab-panel>

            <q-tab-panel name="2">
              <!-- table -->
              <div class="q-pa-md">
                <q-markup-table>
                  <thead>
                    <tr>
                      <th class="text-left">#</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Team</th>
                      <th class="text-left">Total Score</th>
                      <th class="text-left">Total Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="table.length > 0">
                      <tr v-for="(infos, index) in table.slice(0, 25)" :key="infos.id">
                        <td class="text-left">{{ index + 1 }}</td>
                        <td class="text-left">{{ infos.event_name }}</td>
                        <td class="text-left">{{ infos.team_name }}</td>
                        <td class="text-left">{{ infos.score }}</td>
                        <td class="text-left">{{ infos.time }}</td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td class="text-center" colspan="6">There is no data to show</td>
                    </tr>
                  </tbody>
                </q-markup-table>
              </div>
            </q-tab-panel>

            <q-tab-panel name="3">
              <!-- table -->
              <div class="q-pa-md">
                <q-markup-table>
                  <thead>
                    <tr>
                      <th class="text-left">#</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Team</th>
                      <th class="text-left">Total Score</th>
                      <th class="text-left">Total Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="table.length > 0">
                      <tr v-for="(infos, index) in table.slice(0, 9)" :key="infos.id">
                        <td class="text-left">{{ index + 1 }}</td>
                        <td class="text-left">{{ infos.event_name }}</td>
                        <td class="text-left">{{ infos.team_name }}</td>
                        <td class="text-left">{{ infos.score }}</td>
                        <td class="text-left">{{ infos.time }}</td>
                      </tr>
                    </template>
                    <tr v-else>
                      <td class="text-center" colspan="6">There is no data to show</td>
                    </tr>
                  </tbody>
                </q-markup-table>
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
      <sponsors></sponsors>
      <contact-us></contact-us>

      <!--      &lt;!&ndash; Dialog &ndash;&gt;-->
      <!--      <div class="q-pa-md q-gutter-sm">-->
      <!--        <q-dialog v-model="persistent" persistent transition-show="scale" transition-hide="scale">-->
      <!--          <q-card class="bg-primary text-white subscribe-model" style="width: 300px">-->
      <!--            <q-card-section>-->
      <!--              <div class="text-h6">Subscribe</div>-->
      <!--            </q-card-section>-->

      <!--            <q-card-section class="q-pt-none">-->
      <!--              You Have To Login First-->
      <!--            </q-card-section>-->

      <!--            <q-card-actions align="right" class="bg-white text-teal">-->
      <!--              <q-btn flat v-close-popup>-->
      <!--                <router-link class="model-button" to="/sign-In">Login</router-link>-->
      <!--              </q-btn>-->
      <!--              <q-btn flat label="Cancel" color="primary" v-close-popup />-->
      <!--            </q-card-actions>-->
      <!--          </q-card>-->
      <!--        </q-dialog>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent.vue"
import ContactUs from "../../components/home/ContactUs";
import Loading from "@/components/Loading/loading";
import carousel from 'vue-owl-carousel'
import Sponsors from "@/components/home/Sponsors";

export default {
  name: 'EventDetails',
  data: () => ({
    loading: true,
    spinner_loading: false,
    persistent: false,
    errors: null,
    subscribe_info: {
      team_id: null,
      event_id: null,
      code: null,
    },
    isSubscribed: false,
    table: [],
    event_details: [],
    tab: '1'
  }),
  components: { Sponsors, Loading, ContactUs, ButtonComponent },
  mounted() {
    this.$API.web.event.show_event({
      event_id: this.$route.params.id,
    }).then(response => {
      console.log(this.$store.state.userTeam);
      this.event_details = response.data[0];
      if (this.$store.state.userTeam !== null) {
        this.subscribe_info.team_id = this.$store.state.userTeam[0].id;
        this.subscribe_info.code = this.event_details.code;
        this.subscribe_info.event_id = this.event_details.id;
      }
      /*** Check if user is subscribed on current event ***/
      this.check_if_user_subscribed();
      this.loading = false;

    }).catch(() => {
      this.loading = false;
    });

    this.$API.general.leaderboard({ event_id: this.$route.params.id, round: 1 })
      .then(response => {
        this.table = response
      })
  },
  watch: {
    'tab'() {
      this.$API.general.leaderboard({ event_id: this.$route.params.id, round: this.tab })
        .then(response => {
          this.table = response
        })
    }
  },
  methods: {
    redirect_to(e) {
      this.$router.push(e);
    },
    subscribe() {
      this.spinner_loading = true;
      /** If user is not logged in or the user us not in team
       *  we will force him to login first.
       * **/
      if (this.$store.state.userState === false) {
        this.$router.push('/sign-In');
      } else if (this.$store.state.userTeam == null) {
        this.$q.notify({
          message: 'You Have To Join Team First',
          color: 'red'
        })
        this.spinner_loading = false;
      } else {
        /** Here we will check if user is paid for event or no. **/
        let user_id = this.$store.state.userData.id;
        let organizer_id = this.$store.state.settings_website[0].organizer_id;
        this.$API.web.payment.check_if_user_paid({
          user_id: user_id
        })
          .then(response => {
            /** if (target) found that's mean the user is already paid
             *  and we will allow him to subscribe event.
             * **/
            let target = response.data.payments.find(el => el.paid === 1);
            if (target) {
              this.$API.web.event.Subscribe_Event(this.subscribe_info)
                .then(response => {
                  this.$q.notify({
                    message: 'You subscribed successfully',
                    color: 'green'
                  })
                  // this.check_if_user_subscribed();
                  this.spinner_loading = false;
                })
                .catch(error => {
                  console.log(error.message[0]);
                  if (error.message[0] === 'The team id field is required.') {
                    this.$q.notify({
                      message: 'You have to join team first',
                      color: 'red'
                    })
                  } else {
                    this.$q.notify({
                      message: error.message,
                      color: 'red'
                    })
                  }
                  this.spinner_loading = false;
                });
            } else {
              this.$API.web.event.subscribe_payment({
                user_id: user_id,
                organizer_id: organizer_id,
                event_id: this.$route.params.id
              }).then(payResp => {
                if (payResp.data.subscription === 1) {
                  this.isSubscribed = true;
                  this.check_if_user_subscribed();
                }

              }).catch(errPay => {
                if (errPay.status === 400) {
                  this.$q.notify({
                    message: errPay.data.message,
                    color: 'red'
                  })
                }

              })
              /** if user not paid we will redirect link to wro-v website **/
              // window.open(`https://wro-v.com/payments?user_id=${user_id}&orginzer_id=${organizer_id}`, '_blank');
              this.spinner_loading = false;
            }
          }).catch(() => { });
      }
    },
    check_if_user_subscribed() {
      if (this.$store.state.userState === true) {
        this.$API.web.event.Subscribe_status({
          'event_id': this.subscribe_info.event_id,
        })
          .then(response => {
            if (response.data.subscription === 1) {
              this.isSubscribed = true;
            }
          }).catch(() => {
          })
      }
    }
  },
}
</script>

<style scoped>
.event-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.wro-categories {
  font-weight: 500;
}

.wro-categories .wro-categories-textContent {
  /*background-image: url("../../assets/img/competitions/1.png");*/
  background-size: cover;
  background-repeat: no-repeat;
  color: #ffffff;
  max-width: 100%;
  height: 353px;
  margin-bottom: 44px;
  position: relative;
  display: flex;
  align-items: flex-end;
}

.wro-categories .wro-categories-textContent .content {
  position: relative;
  z-index: 2;
  padding: 57px 34px 0px;
  margin-bottom: 18px;
  font-weight: bold;
  display: flex;
  width: 100%;
}

.wro-categories .wro-categories-textContent p {
  font-size: 16px;
  width: max-content;
  position: relative;
  font-weight: 500;
  padding-left: 12px;
  border-left: 5px solid #ffff;
  border-radius: 3px;
}


.overleay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: #00000040;
  z-index: 1;
}

.text {
  font-size: 40px;
  font-weight: 500;
  color: #0A0443;
}

.details-body .button {
  text-align: center !important;
}

.details-body .content-text {
  margin-top: 10px;
}

.details-body .content-text p {
  font-size: 18px;
}

.the-table {
  margin-top: 45px;
}

.the-table>p {}

.the-table .table-header {
  position: relative;
}

.the-table .table-header span {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  color: var(--mainColors);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.the-table .q-markup-table {
  box-shadow: none !important;
}

.the-table td {
  /*box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16)!important;*/
  border-right: 5px solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: 5px solid rgba(0, 0, 0, 0.12) !important;
}

.the-table .tbody {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

thead {
  color: #7C7C7C;
  font-size: 13px;
  font-weight: 600;
}

tr {
  height: 73px !important;
  font-weight: 600 !important;
}

tr img {
  width: 44px;
  height: 44px;
  object-fit: cover;
}

.the-table td:last-of-type {
  border-right: 0px solid rgba(0, 0, 0, 0.12) !important;
}

@media (max-width: 761px) {
  .wro-categories .wro-categories-textContent .content p:nth-child(1) {
    font-size: inherit;
    width: inherit;
  }

  .wro-categories .wro-categories-p span {
    display: none;
  }
}

@media (max-width: 1120px) {
  .content .select-categories {
    /*height: initial;*/
  }

  .content .select-categories-item {
    padding: 30px 0 0px 26px !important;
  }

  .wro-categories .wro-categories-textContent .content p:nth-child(2) {
    padding-right: 20px;
  }

  .wro-categories .wro-categories-textContent .content {
    padding: 57px 10px 0px;
  }

}

@media (max-width: 599px) {
  .wro-categories .wro-categories-textContent {
    height: initial;
  }

  .content .select-categories {
    height: initial;
  }

  .wro-categories .wro-categories-p span {
    width: 45px;
  }
}

.item-img img {
  width: 88px !important;
}
</style>
